<template>
    <modal :name="modalName" width="100%" height="100%" :adaptive="true" @before-open="beforeOpen" @before-close="beforeClose">
        <v-toolbar color="indigo" dark>
            <v-toolbar-title>
                본인 사진(썸네일)
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal" style="right:20px">
                <v-icon>clear</v-icon>
            </v-btn>
        </v-toolbar>

        <div v-show="isLoadedDriverImage" style="width: 100%; height: 100%">
            <div style="width: 80%; height: 100%; float: left;">
                <vue-cropper ref="cropper" :img="cropperOption.img" :output-size="cropperOption.size" :output-type="cropperOption.outputType" :info="cropperOption.info" :full="cropperOption.full"
                             :can-move="cropperOption.canMove" :can-move-box="cropperOption.canMoveBox" :fixed-box="cropperOption.fixedBox" :original="cropperOption.original" :fixed="cropperOption.fixed"
                             :auto-crop="cropperOption.autoCrop" :auto-crop-width="cropperOption.autoCropWidth" :auto-crop-height="cropperOption.autoCropHeight" :center-box="cropperOption.centerBox"
                             :high="cropperOption.high" :canScale="cropperOption.canScale">
                </vue-cropper>
            </div>

            <div style=" width: 20%; height: 100%; float: right; margin-top: 20px;">
                <button type="button" @click="rotateLeft" class="v-btn v-btn--round info"><div class="v-btn__content">rotateLeft</div></button>
                <button type="button" @click="rotateRight" class="v-btn v-btn--round info"><div class="v-btn__content">rotateRight</div></button>
                <button type="button" @click="changeScale(1)" class="v-btn v-btn--round info"><div class="v-btn__content">+</div></button>
                <button type="button" @click="changeScale(-1)" class="v-btn v-btn--round info"><div class="v-btn__content">-</div></button>
                <button type="button" @click="createThumbnail" class="v-btn v-btn--round info"><div class="v-btn__content">create</div></button>
            </div>
        </div>
    </modal>
</template>

<script>
  export default {
    components: {},
    props : {
      modalName: {
        required: false,
        default: 'modal-driver-image-thumbnail-generator',
      }
    },
    data : function() {
      return {
        driverId: null,
        isLoadedDriverImage: false,
        cropperOption: {
          img: '',
          info: true,
          fixed: true,
          size: 1,
          full: false,
          outputType: 'jpeg',
          canMove: true,
          fixedBox: false,
          original: true,
          canMoveBox: true,
          autoCrop: true,
          autoCropWidth: 0,
          autoCropHeight: 0,
          centerBox: true,
          high: true,
          canScale: false
        },
      }
    },
    created : function() {
    },
    mounted() {},
    computed : {},
    watch : {},
    methods: {
      beforeOpen (e) {
        this.driverId = e.params.driverId;

        this.loadDriverImage();
      },
      beforeClose () {
        this.clearModalData();
      },
      closeModal () {
        this.beforeClose();
        this.$modal.hide(this.modalName);
      },
      clearModalData () {
        this.driverId = null;
        this.cropperOption.img = '';
        this.isLoadedDriverImage = false;
      },
      loadDriverImage () {
        this.cropperOption.img = apiHost.adminApiHost + '/attach/view/DRIVER_PICTURE/' + this.driverId + '?v' + Math.random();
        this.isLoadedDriverImage = true;
      },
      saveDriverImageThumbnail (image64) {
        const parameter = {
          method: 'createDriverImageThumbnail',
          id: this.driverId,
          image64: image64
        };

        this.$store.dispatch('banbanAPI', parameter)
          .then(({ data }) => {
            top.getApp.progress.dialog = false;

            alert('등록되었습니다.');
          })
          .catch((error) => {
            if (top.getApp.commonError == null) {
              alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
            }
            top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      },
      rotateLeft () {
        this.$refs.cropper.rotateLeft();
      },
      rotateRight () {
        this.$refs.cropper.rotateRight();
      },
      changeScale(num) {
        num = num || 1;
        this.$refs.cropper.changeScale(num);
      },
      createThumbnail () {
        if(!confirm('등록하시겠습니까?')) return;

        this.$refs.cropper.getCropData((data) => {
          let image64 = data.replace(/^data:image\/[a-z]+;base64,/, "");

          this.saveDriverImageThumbnail(image64);
        });
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        let byteCharacters = atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          let slice = byteCharacters.slice(offset, offset + sliceSize);

          let byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          let byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        let blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/modal/modal-driver-image-thumbnail-generator.vue